export interface WorldCountry {
  code: string;
  name: string;
  dial_code: string;
  region: string;
  flag: string;
}

export const WORLD_COUNTRIES: WorldCountry[] = [
  {
    "code": "GLOBAL",
    "name": "Global / Multi-Region Proxy",
    "dial_code": "+0",
    "region": "Worldwide",
    "flag": "🌍"
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "dial_code": "+880",
    "region": "Asia",
    "flag": "🇧🇩"
  },
  {
    "code": "US",
    "name": "United States",
    "dial_code": "+1",
    "region": "North America",
    "flag": "🇺🇸"
  },
  {
    "code": "GB",
    "name": "United Kingdom",
    "dial_code": "+44",
    "region": "Europe",
    "flag": "🇬🇧"
  },
  {
    "code": "CA",
    "name": "Canada",
    "dial_code": "+1",
    "region": "North America",
    "flag": "🇨🇦"
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "region": "Middle East",
    "flag": "🇦🇪"
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "region": "Middle East",
    "flag": "🇸🇦"
  },
  {
    "code": "IN",
    "name": "India",
    "dial_code": "+91",
    "region": "Asia",
    "flag": "🇮🇳"
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "dial_code": "+92",
    "region": "Asia",
    "flag": "🇵🇰"
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "dial_code": "+60",
    "region": "Asia",
    "flag": "🇲🇾"
  },
  {
    "code": "SG",
    "name": "Singapore",
    "dial_code": "+65",
    "region": "Asia",
    "flag": "🇸🇬"
  },
  {
    "code": "AU",
    "name": "Australia",
    "dial_code": "+61",
    "region": "Oceania",
    "flag": "🇦🇺"
  },
  {
    "code": "DE",
    "name": "Germany",
    "dial_code": "+49",
    "region": "Europe",
    "flag": "🇩🇪"
  },
  {
    "code": "FR",
    "name": "France",
    "dial_code": "+33",
    "region": "Europe",
    "flag": "🇫🇷"
  },
  {
    "code": "IT",
    "name": "Italy",
    "dial_code": "+39",
    "region": "Europe",
    "flag": "🇮🇹"
  },
  {
    "code": "ES",
    "name": "Spain",
    "dial_code": "+34",
    "region": "Europe",
    "flag": "🇪🇸"
  },
  {
    "code": "AF",
    "name": "Afghanistan",
    "dial_code": "+93",
    "region": "Asia",
    "flag": "🇦🇫"
  },
  {
    "code": "AL",
    "name": "Albania",
    "dial_code": "+355",
    "region": "Europe",
    "flag": "🇦🇱"
  },
  {
    "code": "DZ",
    "name": "Algeria",
    "dial_code": "+213",
    "region": "Africa",
    "flag": "🇩🇿"
  },
  {
    "code": "AD",
    "name": "Andorra",
    "dial_code": "+376",
    "region": "Europe",
    "flag": "🇦🇩"
  },
  {
    "code": "AO",
    "name": "Angola",
    "dial_code": "+244",
    "region": "Africa",
    "flag": "🇦🇴"
  },
  {
    "code": "AG",
    "name": "Antigua and Barbuda",
    "dial_code": "+1-268",
    "region": "Americas",
    "flag": "🇦🇬"
  },
  {
    "code": "AR",
    "name": "Argentina",
    "dial_code": "+54",
    "region": "South America",
    "flag": "🇦🇷"
  },
  {
    "code": "AM",
    "name": "Armenia",
    "dial_code": "+374",
    "region": "Asia",
    "flag": "🇦🇲"
  },
  {
    "code": "AT",
    "name": "Austria",
    "dial_code": "+43",
    "region": "Europe",
    "flag": "🇦🇹"
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "dial_code": "+994",
    "region": "Asia",
    "flag": "🇦🇿"
  },
  {
    "code": "BS",
    "name": "Bahamas",
    "dial_code": "+1-242",
    "region": "Americas",
    "flag": "🇧🇸"
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "dial_code": "+973",
    "region": "Middle East",
    "flag": "🇧🇭"
  },
  {
    "code": "BB",
    "name": "Barbados",
    "dial_code": "+1-246",
    "region": "Americas",
    "flag": "🇧🇧"
  },
  {
    "code": "BY",
    "name": "Belarus",
    "dial_code": "+375",
    "region": "Europe",
    "flag": "🇧🇾"
  },
  {
    "code": "BE",
    "name": "Belgium",
    "dial_code": "+32",
    "region": "Europe",
    "flag": "🇧🇪"
  },
  {
    "code": "BZ",
    "name": "Belize",
    "dial_code": "+501",
    "region": "Americas",
    "flag": "🇧🇿"
  },
  {
    "code": "BJ",
    "name": "Benin",
    "dial_code": "+229",
    "region": "Africa",
    "flag": "🇧🇯"
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "dial_code": "+975",
    "region": "Asia",
    "flag": "🇧🇹"
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "dial_code": "+591",
    "region": "South America",
    "flag": "🇧🇴"
  },
  {
    "code": "BA",
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "region": "Europe",
    "flag": "🇧🇦"
  },
  {
    "code": "BW",
    "name": "Botswana",
    "dial_code": "+267",
    "region": "Africa",
    "flag": "🇧🇼"
  },
  {
    "code": "BR",
    "name": "Brazil",
    "dial_code": "+55",
    "region": "South America",
    "flag": "🇧🇷"
  },
  {
    "code": "BN",
    "name": "Brunei",
    "dial_code": "+673",
    "region": "Asia",
    "flag": "🇧🇳"
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "dial_code": "+359",
    "region": "Europe",
    "flag": "🇧🇬"
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "dial_code": "+226",
    "region": "Africa",
    "flag": "🇧🇫"
  },
  {
    "code": "BI",
    "name": "Burundi",
    "dial_code": "+257",
    "region": "Africa",
    "flag": "🇧🇮"
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "dial_code": "+855",
    "region": "Asia",
    "flag": "🇰🇭"
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "dial_code": "+237",
    "region": "Africa",
    "flag": "🇨🇲"
  },
  {
    "code": "CV",
    "name": "Cape Verde",
    "dial_code": "+238",
    "region": "Africa",
    "flag": "🇨🇻"
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "dial_code": "+236",
    "region": "Africa",
    "flag": "🇨🇫"
  },
  {
    "code": "TD",
    "name": "Chad",
    "dial_code": "+235",
    "region": "Africa",
    "flag": "🇹🇩"
  },
  {
    "code": "CL",
    "name": "Chile",
    "dial_code": "+56",
    "region": "South America",
    "flag": "🇨🇱"
  },
  {
    "code": "CN",
    "name": "China",
    "dial_code": "+86",
    "region": "Asia",
    "flag": "🇨🇳"
  },
  {
    "code": "CO",
    "name": "Colombia",
    "dial_code": "+57",
    "region": "South America",
    "flag": "🇨🇴"
  },
  {
    "code": "KM",
    "name": "Comoros",
    "dial_code": "+269",
    "region": "Africa",
    "flag": "🇰🇲"
  },
  {
    "code": "CG",
    "name": "Congo",
    "dial_code": "+242",
    "region": "Africa",
    "flag": "🇨🇬"
  },
  {
    "code": "CD",
    "name": "Congo (DRC)",
    "dial_code": "+243",
    "region": "Africa",
    "flag": "🇨🇩"
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "dial_code": "+506",
    "region": "Americas",
    "flag": "🇨🇷"
  },
  {
    "code": "CI",
    "name": "Ivory Coast",
    "dial_code": "+225",
    "region": "Africa",
    "flag": "🇨🇮"
  },
  {
    "code": "HR",
    "name": "Croatia",
    "dial_code": "+385",
    "region": "Europe",
    "flag": "🇭🇷"
  },
  {
    "code": "CU",
    "name": "Cuba",
    "dial_code": "+53",
    "region": "Americas",
    "flag": "🇨🇺"
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "dial_code": "+357",
    "region": "Europe",
    "flag": "🇨🇾"
  },
  {
    "code": "CZ",
    "name": "Czech Republic",
    "dial_code": "+420",
    "region": "Europe",
    "flag": "🇨🇿"
  },
  {
    "code": "DK",
    "name": "Denmark",
    "dial_code": "+45",
    "region": "Europe",
    "flag": "🇩🇰"
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "dial_code": "+253",
    "region": "Africa",
    "flag": "🇩🇯"
  },
  {
    "code": "DM",
    "name": "Dominica",
    "dial_code": "+1-767",
    "region": "Americas",
    "flag": "🇩🇲"
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "dial_code": "+1-809",
    "region": "Americas",
    "flag": "🇩🇴"
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "dial_code": "+593",
    "region": "South America",
    "flag": "🇪🇨"
  },
  {
    "code": "EG",
    "name": "Egypt",
    "dial_code": "+20",
    "region": "Africa",
    "flag": "🇪🇬"
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "dial_code": "+503",
    "region": "Americas",
    "flag": "🇸🇻"
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "region": "Africa",
    "flag": "🇬🇶"
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "dial_code": "+291",
    "region": "Africa",
    "flag": "🇪🇷"
  },
  {
    "code": "EE",
    "name": "Estonia",
    "dial_code": "+372",
    "region": "Europe",
    "flag": "🇪🇪"
  },
  {
    "code": "SZ",
    "name": "Eswatini",
    "dial_code": "+268",
    "region": "Africa",
    "flag": "🇸🇿"
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "dial_code": "+251",
    "region": "Africa",
    "flag": "🇪🇹"
  },
  {
    "code": "FJ",
    "name": "Fiji",
    "dial_code": "+679",
    "region": "Oceania",
    "flag": "🇫🇯"
  },
  {
    "code": "FI",
    "name": "Finland",
    "dial_code": "+358",
    "region": "Europe",
    "flag": "🇫🇮"
  },
  {
    "code": "GA",
    "name": "Gabon",
    "dial_code": "+241",
    "region": "Africa",
    "flag": "🇬🇦"
  },
  {
    "code": "GM",
    "name": "Gambia",
    "dial_code": "+220",
    "region": "Africa",
    "flag": "🇬🇲"
  },
  {
    "code": "GE",
    "name": "Georgia",
    "dial_code": "+995",
    "region": "Asia",
    "flag": "🇬🇪"
  },
  {
    "code": "GH",
    "name": "Ghana",
    "dial_code": "+233",
    "region": "Africa",
    "flag": "🇬🇭"
  },
  {
    "code": "GR",
    "name": "Greece",
    "dial_code": "+30",
    "region": "Europe",
    "flag": "🇬🇷"
  },
  {
    "code": "GD",
    "name": "Grenada",
    "dial_code": "+1-473",
    "region": "Americas",
    "flag": "🇬🇩"
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "dial_code": "+502",
    "region": "Americas",
    "flag": "🇬🇹"
  },
  {
    "code": "GN",
    "name": "Guinea",
    "dial_code": "+224",
    "region": "Africa",
    "flag": "🇬🇳"
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "region": "Africa",
    "flag": "🇬🇼"
  },
  {
    "code": "GY",
    "name": "Guyana",
    "dial_code": "+592",
    "region": "South America",
    "flag": "🇬🇾"
  },
  {
    "code": "HT",
    "name": "Haiti",
    "dial_code": "+509",
    "region": "Americas",
    "flag": "🇭🇹"
  },
  {
    "code": "HN",
    "name": "Honduras",
    "dial_code": "+504",
    "region": "Americas",
    "flag": "🇭🇳"
  },
  {
    "code": "HK",
    "name": "Hong Kong",
    "dial_code": "+852",
    "region": "Asia",
    "flag": "🇭🇰"
  },
  {
    "code": "HU",
    "name": "Hungary",
    "dial_code": "+36",
    "region": "Europe",
    "flag": "🇭🇺"
  },
  {
    "code": "IS",
    "name": "Iceland",
    "dial_code": "+354",
    "region": "Europe",
    "flag": "🇮🇸"
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "dial_code": "+62",
    "region": "Asia",
    "flag": "🇮🇩"
  },
  {
    "code": "IR",
    "name": "Iran",
    "dial_code": "+98",
    "region": "Middle East",
    "flag": "🇮🇷"
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "dial_code": "+964",
    "region": "Middle East",
    "flag": "🇮🇶"
  },
  {
    "code": "IE",
    "name": "Ireland",
    "dial_code": "+353",
    "region": "Europe",
    "flag": "🇮🇪"
  },
  {
    "code": "IL",
    "name": "Israel",
    "dial_code": "+972",
    "region": "Middle East",
    "flag": "🇮🇱"
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "dial_code": "+1-876",
    "region": "Americas",
    "flag": "🇯🇲"
  },
  {
    "code": "JP",
    "name": "Japan",
    "dial_code": "+81",
    "region": "Asia",
    "flag": "🇯🇵"
  },
  {
    "code": "JO",
    "name": "Jordan",
    "dial_code": "+962",
    "region": "Middle East",
    "flag": "🇯🇴"
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "dial_code": "+7",
    "region": "Asia",
    "flag": "🇰🇿"
  },
  {
    "code": "KE",
    "name": "Kenya",
    "dial_code": "+254",
    "region": "Africa",
    "flag": "🇰🇪"
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "dial_code": "+686",
    "region": "Oceania",
    "flag": "🇰🇮"
  },
  {
    "code": "KP",
    "name": "North Korea",
    "dial_code": "+850",
    "region": "Asia",
    "flag": "🇰🇵"
  },
  {
    "code": "KR",
    "name": "South Korea",
    "dial_code": "+82",
    "region": "Asia",
    "flag": "🇰🇷"
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "dial_code": "+965",
    "region": "Middle East",
    "flag": "🇰🇼"
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "region": "Asia",
    "flag": "🇰🇬"
  },
  {
    "code": "LA",
    "name": "Laos",
    "dial_code": "+856",
    "region": "Asia",
    "flag": "🇱🇦"
  },
  {
    "code": "LV",
    "name": "Latvia",
    "dial_code": "+371",
    "region": "Europe",
    "flag": "🇱🇻"
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "dial_code": "+961",
    "region": "Middle East",
    "flag": "🇱🇧"
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "dial_code": "+266",
    "region": "Africa",
    "flag": "🇱🇸"
  },
  {
    "code": "LR",
    "name": "Liberia",
    "dial_code": "+231",
    "region": "Africa",
    "flag": "🇱🇷"
  },
  {
    "code": "LY",
    "name": "Libya",
    "dial_code": "+218",
    "region": "Africa",
    "flag": "🇱🇾"
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "dial_code": "+423",
    "region": "Europe",
    "flag": "🇱🇮"
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "dial_code": "+370",
    "region": "Europe",
    "flag": "🇱🇹"
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "dial_code": "+352",
    "region": "Europe",
    "flag": "🇱🇺"
  },
  {
    "code": "MO",
    "name": "Macau",
    "dial_code": "+853",
    "region": "Asia",
    "flag": "🇲🇴"
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "dial_code": "+261",
    "region": "Africa",
    "flag": "🇲🇬"
  },
  {
    "code": "MW",
    "name": "Malawi",
    "dial_code": "+265",
    "region": "Africa",
    "flag": "🇲🇼"
  },
  {
    "code": "MV",
    "name": "Maldives",
    "dial_code": "+960",
    "region": "Asia",
    "flag": "🇲🇻"
  },
  {
    "code": "ML",
    "name": "Mali",
    "dial_code": "+223",
    "region": "Africa",
    "flag": "🇲🇱"
  },
  {
    "code": "MT",
    "name": "Malta",
    "dial_code": "+356",
    "region": "Europe",
    "flag": "🇲🇹"
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "dial_code": "+692",
    "region": "Oceania",
    "flag": "🇲🇭"
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "dial_code": "+222",
    "region": "Africa",
    "flag": "🇲🇷"
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "dial_code": "+230",
    "region": "Africa",
    "flag": "🇲🇺"
  },
  {
    "code": "MX",
    "name": "Mexico",
    "dial_code": "+52",
    "region": "North America",
    "flag": "🇲🇽"
  },
  {
    "code": "FM",
    "name": "Micronesia",
    "dial_code": "+691",
    "region": "Oceania",
    "flag": "🇫🇲"
  },
  {
    "code": "MD",
    "name": "Moldova",
    "dial_code": "+373",
    "region": "Europe",
    "flag": "🇲🇩"
  },
  {
    "code": "MC",
    "name": "Monaco",
    "dial_code": "+377",
    "region": "Europe",
    "flag": "🇲🇨"
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "dial_code": "+976",
    "region": "Asia",
    "flag": "🇲🇳"
  },
  {
    "code": "ME",
    "name": "Montenegro",
    "dial_code": "+382",
    "region": "Europe",
    "flag": "🇲🇪"
  },
  {
    "code": "MA",
    "name": "Morocco",
    "dial_code": "+212",
    "region": "Africa",
    "flag": "🇲🇦"
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "dial_code": "+258",
    "region": "Africa",
    "flag": "🇲🇿"
  },
  {
    "code": "MM",
    "name": "Myanmar",
    "dial_code": "+95",
    "region": "Asia",
    "flag": "🇲🇲"
  },
  {
    "code": "NA",
    "name": "Namibia",
    "dial_code": "+264",
    "region": "Africa",
    "flag": "🇳🇦"
  },
  {
    "code": "NR",
    "name": "Nauru",
    "dial_code": "+674",
    "region": "Oceania",
    "flag": "🇳🇷"
  },
  {
    "code": "NP",
    "name": "Nepal",
    "dial_code": "+977",
    "region": "Asia",
    "flag": "🇳🇵"
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "dial_code": "+31",
    "region": "Europe",
    "flag": "🇳🇱"
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "dial_code": "+64",
    "region": "Oceania",
    "flag": "🇳🇿"
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "dial_code": "+505",
    "region": "Americas",
    "flag": "🇳🇮"
  },
  {
    "code": "NE",
    "name": "Niger",
    "dial_code": "+227",
    "region": "Africa",
    "flag": "🇳🇪"
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "dial_code": "+234",
    "region": "Africa",
    "flag": "🇳🇬"
  },
  {
    "code": "MK",
    "name": "North Macedonia",
    "dial_code": "+389",
    "region": "Europe",
    "flag": "🇲🇰"
  },
  {
    "code": "NO",
    "name": "Norway",
    "dial_code": "+47",
    "region": "Europe",
    "flag": "🇳🇴"
  },
  {
    "code": "OM",
    "name": "Oman",
    "dial_code": "+968",
    "region": "Middle East",
    "flag": "🇴🇲"
  },
  {
    "code": "PW",
    "name": "Palau",
    "dial_code": "+680",
    "region": "Oceania",
    "flag": "🇵🇼"
  },
  {
    "code": "PS",
    "name": "Palestine",
    "dial_code": "+970",
    "region": "Middle East",
    "flag": "🇵🇸"
  },
  {
    "code": "PA",
    "name": "Panama",
    "dial_code": "+507",
    "region": "Americas",
    "flag": "🇵🇦"
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "region": "Oceania",
    "flag": "🇵🇬"
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "dial_code": "+595",
    "region": "South America",
    "flag": "🇵🇾"
  },
  {
    "code": "PE",
    "name": "Peru",
    "dial_code": "+51",
    "region": "South America",
    "flag": "🇵🇪"
  },
  {
    "code": "PH",
    "name": "Philippines",
    "dial_code": "+63",
    "region": "Asia",
    "flag": "🇵🇭"
  },
  {
    "code": "PL",
    "name": "Poland",
    "dial_code": "+48",
    "region": "Europe",
    "flag": "🇵🇱"
  },
  {
    "code": "PT",
    "name": "Portugal",
    "dial_code": "+351",
    "region": "Europe",
    "flag": "🇵🇹"
  },
  {
    "code": "QA",
    "name": "Qatar",
    "dial_code": "+974",
    "region": "Middle East",
    "flag": "🇶🇦"
  },
  {
    "code": "RO",
    "name": "Romania",
    "dial_code": "+40",
    "region": "Europe",
    "flag": "🇷🇴"
  },
  {
    "code": "RU",
    "name": "Russia",
    "dial_code": "+7",
    "region": "Europe / Asia",
    "flag": "🇷🇺"
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "dial_code": "+250",
    "region": "Africa",
    "flag": "🇷🇼"
  },
  {
    "code": "KN",
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1-869",
    "region": "Americas",
    "flag": "🇰🇳"
  },
  {
    "code": "LC",
    "name": "Saint Lucia",
    "dial_code": "+1-758",
    "region": "Americas",
    "flag": "🇱🇨"
  },
  {
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1-784",
    "region": "Americas",
    "flag": "🇻🇨"
  },
  {
    "code": "WS",
    "name": "Samoa",
    "dial_code": "+685",
    "region": "Oceania",
    "flag": "🇼🇸"
  },
  {
    "code": "SM",
    "name": "San Marino",
    "dial_code": "+378",
    "region": "Europe",
    "flag": "🇸🇲"
  },
  {
    "code": "ST",
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "region": "Africa",
    "flag": "🇸🇹"
  },
  {
    "code": "SN",
    "name": "Senegal",
    "dial_code": "+221",
    "region": "Africa",
    "flag": "🇸🇳"
  },
  {
    "code": "RS",
    "name": "Serbia",
    "dial_code": "+381",
    "region": "Europe",
    "flag": "🇷🇸"
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "dial_code": "+248",
    "region": "Africa",
    "flag": "🇸🇨"
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "dial_code": "+232",
    "region": "Africa",
    "flag": "🇸🇱"
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "dial_code": "+421",
    "region": "Europe",
    "flag": "🇸🇰"
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "dial_code": "+386",
    "region": "Europe",
    "flag": "🇸🇮"
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "dial_code": "+677",
    "region": "Oceania",
    "flag": "🇸🇧"
  },
  {
    "code": "SO",
    "name": "Somalia",
    "dial_code": "+252",
    "region": "Africa",
    "flag": "🇸🇴"
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "dial_code": "+27",
    "region": "Africa",
    "flag": "🇿🇦"
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "dial_code": "+211",
    "region": "Africa",
    "flag": "🇸🇸"
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "dial_code": "+94",
    "region": "Asia",
    "flag": "🇱🇰"
  },
  {
    "code": "SD",
    "name": "Sudan",
    "dial_code": "+249",
    "region": "Africa",
    "flag": "🇸🇩"
  },
  {
    "code": "SR",
    "name": "Suriname",
    "dial_code": "+597",
    "region": "South America",
    "flag": "🇸🇷"
  },
  {
    "code": "SE",
    "name": "Sweden",
    "dial_code": "+46",
    "region": "Europe",
    "flag": "🇸🇪"
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "dial_code": "+41",
    "region": "Europe",
    "flag": "🇨🇭"
  },
  {
    "code": "SY",
    "name": "Syria",
    "dial_code": "+963",
    "region": "Middle East",
    "flag": "🇸🇾"
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "dial_code": "+886",
    "region": "Asia",
    "flag": "🇹🇼"
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "dial_code": "+992",
    "region": "Asia",
    "flag": "🇹🇯"
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "dial_code": "+255",
    "region": "Africa",
    "flag": "🇹🇿"
  },
  {
    "code": "TH",
    "name": "Thailand",
    "dial_code": "+66",
    "region": "Asia",
    "flag": "🇹🇭"
  },
  {
    "code": "TL",
    "name": "Timor-Leste",
    "dial_code": "+670",
    "region": "Asia",
    "flag": "🇹🇱"
  },
  {
    "code": "TG",
    "name": "Togo",
    "dial_code": "+228",
    "region": "Africa",
    "flag": "🇹🇬"
  },
  {
    "code": "TO",
    "name": "Tonga",
    "dial_code": "+676",
    "region": "Oceania",
    "flag": "🇹🇴"
  },
  {
    "code": "TT",
    "name": "Trinidad and Tobago",
    "dial_code": "+1-868",
    "region": "Americas",
    "flag": "🇹🇹"
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "dial_code": "+216",
    "region": "Africa",
    "flag": "🇹🇳"
  },
  {
    "code": "TR",
    "name": "Turkey",
    "dial_code": "+90",
    "region": "Europe / Asia",
    "flag": "🇹🇷"
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "dial_code": "+993",
    "region": "Asia",
    "flag": "🇹🇲"
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "dial_code": "+688",
    "region": "Oceania",
    "flag": "🇹🇻"
  },
  {
    "code": "UG",
    "name": "Uganda",
    "dial_code": "+256",
    "region": "Africa",
    "flag": "🇺🇬"
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "dial_code": "+380",
    "region": "Europe",
    "flag": "🇺🇦"
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "dial_code": "+598",
    "region": "South America",
    "flag": "🇺🇾"
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "dial_code": "+998",
    "region": "Asia",
    "flag": "🇺🇿"
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "dial_code": "+678",
    "region": "Oceania",
    "flag": "🇻🇺"
  },
  {
    "code": "VA",
    "name": "Vatican City",
    "dial_code": "+39",
    "region": "Europe",
    "flag": "🇻🇦"
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "dial_code": "+58",
    "region": "South America",
    "flag": "🇻🇪"
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "dial_code": "+84",
    "region": "Asia",
    "flag": "🇻🇳"
  },
  {
    "code": "YE",
    "name": "Yemen",
    "dial_code": "+967",
    "region": "Middle East",
    "flag": "🇾🇪"
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "dial_code": "+260",
    "region": "Africa",
    "flag": "🇿🇲"
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "dial_code": "+263",
    "region": "Africa",
    "flag": "🇿🇼"
  }
];
